import { Loader } from "@circle-react-uikit/Loader";

export const EmbedLoading = () => (
  <div className="bg-secondary border-input flex h-[320px] flex-col items-center justify-center space-y-4 rounded-lg border border-dashed">
    <Loader />
  </div>
);
